import React, { useState, useEffect } from "react";
import { styles } from "./styles";
import Quotationfile from "./Quotationfile";

const Quotations = ({ initialRows = [] }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [rows, setRows] = useState(initialRows);
  const [totalAmount, setTotalAmount] = useState(0);
  const [orderId, setOrderId] = useState("Order-");
  const [fullName, setFullName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postCode, setPostCode] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [editableTotalAmount, setEditableTotalAmount] = useState("£0.00");
  const [editableAmountPayable, setEditableAmountPayable] = useState("£0.00");

  const handleOrderIdChange = (event) => {
    let { value } = event.target;
    // Ensure the value always starts with 'Order-'
    if (!value.startsWith("Order-")) {
      value = "Order-" + value.replace(/^Order-*/, "");
    }
    setOrderId(value);
  };

  const handleFullNameChange = (event) => {
    setFullName(event.target.value);
  };

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handlePostCodeChange = (event) => {
    setPostCode(event.target.value);
  };

  const handleServiceTypeChange = (event) => {
    setServiceType(event.target.value);
  };

  useEffect(() => {
    // Update editable fields with formatted values whenever totalAmount changes
    setEditableTotalAmount(`£${totalAmount.toFixed(2)}`);
    setEditableAmountPayable(`£${totalAmount.toFixed(2)}`);
  }, [totalAmount]);

  const handlePreviewClick = () => {
    setShowPreview(true);
  };

  const handleTotalAmountChange = (event) => {
    const { value } = event.target;
    setEditableTotalAmount(value);
    setEditableAmountPayable(value);
    const numericValue = parseFloat(value.replace(/[^0-9.-]+/g, ""));
    if (!isNaN(numericValue)) {
      setTotalAmount(numericValue);
    }
  };

  const customerData = {
    orderId,
    fullName,
    phoneNumber,
    postCode,
    serviceType,
    totalAmount,
    quotationId: orderId, // Assuming orderId should be used as quotationId
  };

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[98%] mx-auto bg-white rounded-xl">
        <div className="px-4 py-8 md:px-16">
          <div className="p-2">
            <div className="p-2">
              <div
                className="text-2xl font-semibold text-blue-700 mb-4"
                style={styles.invoiceHeading}
              >
                Quotation
              </div>
              <div className="flex flex-col md:flex-row items-center mb-8">
                <div
                  className="text-sm font-semibold text-blue-700 mb-2 md:mb-0 md:mr-4"
                  style={styles.invoiceHeading}
                >
                  Order ID
                </div>
                <div className="w-full md:w-48 p-2 border border-gray-800 border-opacity-50 rounded-xl flex items-center">
                  <input
                    type="text"
                    value={orderId}
                    onChange={handleOrderIdChange}
                    className="text-sm font-normal w-full"
                    style={styles.robotoText}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 px-8 py-2">
              <div>
                <div
                  className="text-sm font-semibold text-blue-700 mb-1"
                  style={styles.invoiceHeading}
                >
                  Name
                </div>
                <div className="p-2 border border-gray-800 border-opacity-50 rounded-xl flex items-center">
                  <input
                    type="text"
                    value={fullName}
                    onChange={handleFullNameChange}
                    className="text-sm font-normal w-full"
                    style={styles.robotoText}
                  />
                </div>
              </div>
              <div>
                <div
                  className="text-sm font-semibold text-blue-700 mb-1"
                  style={styles.invoiceHeading}
                >
                  Phone Number
                </div>
                <div className="p-2 border border-gray-800 border-opacity-50 rounded-xl flex items-center">
                  <input
                    type="text"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    className="text-sm font-normal w-full"
                    style={styles.robotoText}
                  />
                </div>
              </div>
              <div>
                <div
                  className="text-sm font-semibold text-blue-700 mb-1"
                  style={styles.invoiceHeading}
                >
                  Post Code
                </div>
                <div className="p-2 border border-gray-800 border-opacity-50 rounded-xl flex items-center">
                  <input
                    type="text"
                    value={postCode}
                    onChange={handlePostCodeChange}
                    className="text-sm font-normal w-full"
                    style={styles.robotoText}
                  />
                </div>
              </div>
              <div>
                <div
                  className="text-sm font-semibold text-blue-700 mb-1"
                  style={styles.invoiceHeading}
                >
                  Service Type
                </div>
                <div className="p-2 border border-gray-800 border-opacity-50 rounded-xl flex items-center">
                  <input
                    type="text"
                    value={serviceType}
                    onChange={handleServiceTypeChange}
                    className="text-sm font-normal w-full"
                    style={styles.robotoText}
                  />
                </div>
              </div>
              <div>
                <div
                  className="text-sm font-semibold text-blue-700 mb-1"
                  style={styles.invoiceHeading}
                >
                  Total Amount
                </div>
                <div className="p-2 border border-gray-800 border-opacity-50 rounded-xl flex items-center">
                  <input
                    type="text"
                    value={editableTotalAmount}
                    onChange={handleTotalAmountChange}
                    className="text-sm font-normal w-full"
                    style={styles.robotoText}
                  />
                </div>
              </div>
              {/* Amount Payable field is now synchronized with Total Amount */}
              <div>
                <div
                  className="text-sm font-semibold text-blue-700 mb-1"
                  style={styles.invoiceHeading}
                >
                  Amount Payable
                </div>
                <div className="p-2 border border-gray-800 border-opacity-50 rounded-xl">
                  <div
                    className="text-sm font-normal"
                    style={styles.centerText}
                  >
                    {editableAmountPayable}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Preview button */}
          <div className="flex justify-center mt-8">
            <button
              className="h-10 w-40 text-white bg-navBg font-semibold rounded-lg"
              onClick={handlePreviewClick}
            >
              Preview
            </button>
          </div>
          {showPreview && (
            <Quotationfile
              customerData={customerData}
              rows={rows}
              setRows={setRows}
              editableTotalAmount={editableTotalAmount}
              editableAmountPayable={editableAmountPayable}
              quotationId={orderId}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Quotations;
